import uniqid from 'uniqid';
import moment from 'moment-timezone';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import { getSectionOrderForParsingCrqData } from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-order';
import { createCrqSectionGetCurrentFields } from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/current-fields';
import { createFieldDataObjAndArray } from 'AppSrc/core/components/forms/form-section-utility-functions';
import {
  fullSectionParameterFieldMap,
  workInfoItemParameterMap,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/field-parameter-map';
import {
  formatApiValueForForm,
  getBlankValueForFieldType,
} from 'AppSrc/core/components/forms/form-base-components/utility/format-api-value-for-form';
import {
  SECTION_TITLES,
  CHANGE_QUESTIONS,
  WORK_INFORMATION_ITEMS,
  CHANGE_REQUEST_SUMMARY,
  RELATIONSHIPS,
  COMPLETION_REVIEW,
  APPROVERS_SECTION,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import {
  CI_UNAVAILABILITY,
  // CHECK_FIXED_QUESTIONARIES,
  CHECK_INVENTORY_UPDATED,
} from 'AppSrc/core/components/forms/form-types/completion-review/form-definition/section-constants';
import {
  MOBILE,
  FIXED,
  BUSINESS_JUSTIFICATION,
  BUSINESS_JUSTIFICATION_FIXED,
  IMPACT_LEVEL_1,
  IMPACT_LEVEL_2,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { getCurrentFields as getWorkInfoItemFields } from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-modal';
import { getCurrentFields as getRelationshipFields } from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/relationships-modal';
import { getCurrentFields as getCiUnavailabilityFields } from 'AppSrc/core/components/forms/form-types/completion-review/section-ci/ci-unavailability-modal';
// the filed id and section id for work info items are both called WORK_INFO_ITEMS.
// to avoid a clash, we rename the field id
import {
  WORK_INFORMATION_ITEMS_FIELD_ID,
  ATTACHED_FILE,
  NETWORK_IT_SECURITY_ASSESSMENT_NOT_REQUIRED,
  PEER_REJECTED_TYPE,
  PEER_APPROVED_TYPE,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-constants';
import { CHANGE_TYPE } from 'AppSrc/core/components/forms/form-types/create-crq/section-one/section-one';
import {
  selectNetworkParamsId,
  selectOLOReqIntServices,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-one/section-one-constants';
import {
  selectChangeSlaId,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-two/section-two-constants';
import {
  isRelationshipTypeRecognised,
  getRelationshipSectionValuesFromApiRelationship,
  getCiUnavailabilitySectionValuesFromApiRelationship,
} from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-section-logic';
import {
  ADD_RELATIONSHIPS,
  RELATIONSHIP_TYPE_API_PARAMETER,
  // RT_CI_UNAVAILABILITY,
  IMPACTED_LOCATION,
} from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/relationship-constants';
import { prefixStringWithIndexPlusOne } from 'AppSrc/core/utility-functions/string-fun';
import {
  unpackBusinessJustification,
  unpackNetworkItSecurityAssesmentNotRequired,
  unpackApprovalHistoryWiis,
} from 'AppSrc/core/work-info-items/work-info-item-utils';
import displayOptionsJSON from 'AppSrc/core/components/forms/data/display-options.json';
import { shouldWiiFromServerBeIgnored } from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-logic';
import { getStatusNameForApproval } from 'AppSrc/core/approvers/approval-statuses';
import {
  getTimingTextForValue,
  getNetworkTextForValue,
  // getDateDisplay,
} from './crq-table-utils';
import {
  getStatusValueForParameter,
  isStatusPeerReview,
} from './crq-statuses';

const getIsServiceFromICM = (services) => {
  const crqService = services;
  // const serVice = 'Network: International Data & IP (IVC/IPX)';
  return displayOptionsJSON['services-fixed-internationalcm'].some((servicesvalues) => crqService === servicesvalues.value);
};
// services-fixed-olo
const getIsServiceFromOLOInternational = (services) => {
  const crqService = services;
  // const serVice = 'Network: International Data & IP (IVC/IPX)';
  // return displayOptionsJSON['services-fixed-olo'].some((servicesvalues) => crqService === servicesvalues.value);
  return crqService === 'Network: International Other Licensed Operator (OLO)';
};
const wki = {};
const getPopulatedValuesForSection = ({
  sectionFields,
  sectionValues,
  ClearApprovers,
  Status,
  // network,
}) => {
  const populatedValues = {};
  // iterate through the fields and add the relevant value to the populatedValues object
  sectionFields.forEach((field) => {
    const {
      id,
      fieldType,
    } = field.componentData;
    // We are checking here if Wii logs include Service Impact Assessment mobile or not
    const hasTrpWiiValue = window.sessionStorage.getItem('workInfoData');
    // Below variable includes the text of TRP exclusion details
    const trpExclusionReason = window.sessionStorage.getItem('trpExclsuionNote');

    const hasTrpWiiValueFixed = window.sessionStorage.getItem('workInfoDataFixed');

    const trpExclusionReasonFixed = window.sessionStorage.getItem('trpExclsuionNoteFixed');

    let apiValueNew = '';

    if ((id === 'technology-plan-required' && hasTrpWiiValue === 'true') || (id === 'technology-plan-required-fixed' && hasTrpWiiValueFixed === 'true')) {
      apiValueNew = 'Yes';
    }
    if ((id === 'technology-plan-required' && hasTrpWiiValue === 'false') || (id === 'technology-plan-required-fixed' && hasTrpWiiValueFixed === 'false')) {
      apiValueNew = 'No';
    }
    if (id === 'technology-plan-exclusion') {
      apiValueNew = trpExclusionReason;
    }
    if (id === 'technology-plan-exclusion-fixed') {
      apiValueNew = trpExclusionReasonFixed;
    }
    // const filteredApiValue = (apiValueNew !== null && network === 'Mobile') ? apiValueNew : null;
    const filteredApiValue = apiValueNew ? apiValueNew : null;
    const apiValue = sectionValues && sectionValues[id] ? sectionValues[id] : filteredApiValue;

    // parse the api value to convert it to the format for the form
    // this is normally based on fieldType, but some fields need specific
    // parsing based on id
    let parsedValue = formatApiValueForForm({
      value: apiValue,
      fieldType,
      fieldId: id,
    });

    const blankValue = getBlankValueForFieldType(fieldType);
    // const ApprovalsFilter = parsedValue;
    // const fixedQuestionPresent = CHECK_FIXED_QUESTIONARIES.includes(id);
    const CheckInventaryUpdated = CHECK_INVENTORY_UPDATED.includes(id);
    if (id === 'approver_group_names' && parsedValue !== null) {
      const idToRemove = '5';
      const id1 = '1';
      const id2 = '2';

      if (Status === '3' && ClearApprovers) {
        const ApprovalsFilter = parsedValue.filter((item) => {
          // const abc = (item.status !== idToRemove || item.status !== id1);
          // return abc;
          if (item.status === idToRemove || item.status === id1 || item.status === id2) {
            return false;
          }
          return true;
        });
        const updatedApproverlsFilter = ApprovalsFilter.filter((groupValues) => {
          console.log('>>>groupValues Data', groupValues);
          return groupValues.name !== undefined;
        });
        parsedValue = updatedApproverlsFilter;
      }
      else if (Status === '5') {
        const ApprovalsFilter = parsedValue.filter((item) => {
          // to filter out individual data from approver group
          if (item.status === idToRemove || item.status === id1 || item.status === id2) {
            return false;
          }
          return true;
        });
        const updatedApproverlsFilter = ApprovalsFilter.filter((groupValues) => {
          console.log('140', groupValues);
          return groupValues.name !== undefined;
        });
        parsedValue = updatedApproverlsFilter;
      }
    }
    // if (fixedQuestionPresent && parsedValue !== null) {
    //   const TextValue = parsedValue.map((item) => {
    //     if (item === '10') {
    //       return 'Yes';
    //     }
    //     if (item === '20') {
    //       return 'No';
    //     }
    //     return item;
    //   });
    //   parsedValue = TextValue;
    // }
    // if (CheckInventaryUpdated && parsedValue !== null) {
    //   const TextValue = parsedValue.map((item) => {
    //     if (item === '10') {
    //       return 'Yes';
    //     }
    //     if (item === '20') {
    //       return 'No';
    //     }
    //     return undefined;
    //   });
    //   parsedValue = TextValue;
    // }
    // populate our object with either the parsed value, or the default value for the field type
    // Note that in the case of parsing an existing CRQ, we don't want to populate with initalValues
    // As the data displayed should reflect the server value and not the default form value
    if (CheckInventaryUpdated && parsedValue !== null) {
      const TextValue = parsedValue.map((item) => {
        if (item === '30') {
          return undefined;
        }
        return item;
      });
      parsedValue = TextValue;
    }
    populatedValues[id] = parsedValue !== null ? parsedValue : blankValue;
  });
  return populatedValues;
};


// convert workInfoItem server data into modalData for the WII section modal field
const getModalDataForWorkInfoItems = (workInfoItems, selectedNetwork) => {
  const sectionFields = getWorkInfoItemFields({});
  const modalData = {
    formSectionsByDisplayOrder: [],
    dataByFormSectionId: {},
  };
  workInfoItems.forEach((workInfoItem) => {
    // some work items with autogenerated text from remedy should be ignored
    // and not inculded in the form data
    if (shouldWiiFromServerBeIgnored(workInfoItem)) {
      return;
    }
    const {
      id,
      network,
      attachment,
      locked,
      notes,
      submitted,
      view_access: viewAccess,
    } = workInfoItem;
    modalData.formSectionsByDisplayOrder.push(id);
    const sectionValues = {};
    workInfoItemParameterMap.forEach(({
      field,
      param,
    }) => {
      sectionValues[field] = workInfoItem[param];
    });
    const populatedValues = getPopulatedValuesForSection({
      sectionValues,
      sectionFields,
    });
    // the attachment values need to be added based on data from the surrounding
    // work info item
    const fileName = attachment ? attachment.name : null;
    // attachments don't have their own id, so we use the wii id as the file id
    // but only if there is an attachment
    const fileId = fileName ? id : null;
    const attachmentData = attachment ? {
      fileId,
      fileName,
      // also add metadata of the crq_id and the network
      // to allow download
      crqId: workInfoItem.crq_id,
      network,
    } : null;
    populatedValues[ATTACHED_FILE] = attachmentData;
    const wiiData = createFieldDataObjAndArray({
      currentFields: sectionFields,
      values: populatedValues,
      selectedNetwork,
    });
    modalData.dataByFormSectionId[id] = {
      ...wiiData,
      sectionId: id,
      // indicate in form data that this is an existing work info item
      workInfoItemId: id,
      // add other wii metadata into the modal data
      locked,
      viewAccess,
      notes,
      submitted,
    };
  });
  return modalData;
};

// convert relationship data into modal data for the relationships section
const getModalDataForRelationships = (relationships = [], selectedNetwork) => {
  const sectionFields = getRelationshipFields({});
  const modalData = {
    formSectionsByDisplayOrder: [],
    dataByFormSectionId: {},
  };
  relationships.forEach((relationship) => {
    const { id } = relationship;
    const typeRecognised = isRelationshipTypeRecognised(relationship[RELATIONSHIP_TYPE_API_PARAMETER]);
    console.log(typeRecognised);
    // The crq data can contain relationships with types we are not interested in
    // These should be ignored by the front end
    // if (!typeRecognised) { return; }
    modalData.formSectionsByDisplayOrder.push(id);
    // first fill in the value for the relationship lookup

    const sectionValues = getRelationshipSectionValuesFromApiRelationship(relationship);


    const populatedValues = getPopulatedValuesForSection({
      sectionValues,
      sectionFields,
    });
    const relationshipData = createFieldDataObjAndArray({
      currentFields: sectionFields,
      values: populatedValues,
      selectedNetwork,
      noOverwrite: true,
    });
    modalData.dataByFormSectionId[id] = {
      ...relationshipData,
      sectionId: id,
      // indicate in form data that this is an existing relationship
      relationshipId: id,
    };
  });

  return modalData;
};
// convert CI Unavailability data into modal data for the Completion Review section
// data comes from relationships
const getModalDataForCiUnavailability = (relationships = [], selectedNetwork) => {
  const sectionFields = getCiUnavailabilityFields({});
  const modalData = {
    formSectionsByDisplayOrder: [],
    dataByFormSectionId: {},
  };
  relationships.forEach((relationship) => {
    const { id } = relationship;
    // The unavailability is identified if there is a ua_type attribute
    const isCiUnavailability = relationship.ua_type;
    if (isCiUnavailability) {
      modalData.formSectionsByDisplayOrder.push(id);

      const sectionValues = getCiUnavailabilitySectionValuesFromApiRelationship(relationship);

      const populatedValues = getPopulatedValuesForSection({
        sectionValues,
        sectionFields,
      });
      const relationshipData = createFieldDataObjAndArray({
        currentFields: sectionFields,
        values: populatedValues,
        selectedNetwork,
        noOverwrite: true,
      });
      modalData.dataByFormSectionId[id] = {
        ...relationshipData,
        sectionId: id,
        // indicate in form data that this is an existing relationship
        relationshipId: id,
      };
    }
  });

  return modalData;
};

// method to populate the valuesBySection object with the values
// for that section, from the crq server data
const addValuesForSection = ({
  valuesBySection,
  section,
  crqData,
}) => {
  const { sectionId, fields } = section;
  valuesBySection[sectionId] = {};
  fields.forEach(({ param, field }) => {
    const value = crqData[param];
    if (value !== null && value !== undefined) {
      valuesBySection[sectionId][field] = value;
    }
  });
};


const inferAdditionalApprovalHistory = (params = {}) => {
  const {
    status,
    approvers,
    approvalHistoryFromWiis,
    peerReviewerGroup,
    peerReviewerName,
    peerReviewerId,
    statusReason,
  } = params;

  const undatedHistory = [];
  const datedHistory = [];
  const peerReviewStatus = isStatusPeerReview(status);

  // we have to add a pending history item if in peerReview
  // adding validation with status reason for hiding pending in circuit check approvals history.
  if (peerReviewStatus && statusReason !== '10500') {
    undatedHistory.push({
      comment: null,
      date: null,
      group: peerReviewerGroup,
      peer: peerReviewerName || peerReviewerId, // apparently TIL doesn't send name back properly
      status: 'Pending',
      type: 'Peer', // <- hardcoded for now
      id: uniqid(), // We need to create an id for this created approval history for react
    });
  }

  if (approvers) {
    approvers.forEach((approverItem) => {
      const approvalStatus = getStatusNameForApproval(approverItem.status);
      // const date = getDateDisplay(approverItem.last_action);
      // Previously only date out of last_action was mapped to date field, now passing entire last_action.
      const date = approverItem.last_action;
      const assignee = approverItem.assignee;
      const rejectionReason = approvalStatus === 'Rejected' && wki.wki.filter((item) => item.notes.includes('Rejection Reason') && item.notes.includes(approverItem.signature));
      // to resolve fail to load crq having no rejection reason and signature id
      let comments = '';
      if (approvalStatus === 'Rejected' && rejectionReason.length === 0) {
        comments = '';
      }
      else {
        comments = approverItem.reason ? approverItem.reason : rejectionReason && rejectionReason[0].notes.split('\n')[0];
      }
      const historyItem = {
        comment: comments,
        date,
        assignee,
        group: approverItem.group ? approverItem.group : null,
        groupId: approverItem.group_id ? approverItem.group_id : null,
        peer: approverItem.name ? approverItem.name : null,
        status: approvalStatus,
        signature: approverItem.signature ? approverItem.signature : null,
        actionable: approverItem.actionable ? approverItem.actionable : null,
        // type for history items based on approvers is Approvals
        type: approverItem.type ? approverItem.type : 'Approvals',
        id: uniqid(), // We need to create an id for this created approval history for react
        userId: approverItem.id, // I mean it looks like a userId... We can't set this to id though as react is using that for keys
        // groupId: approverItem.group_id ? approverItem.group_id : null,
        // assignee,
      };
      if (!historyItem.date) {
        undatedHistory.push(historyItem);
        return null;
      }
      datedHistory.push(historyItem);
      return null;
    });
  }

  if (approvalHistoryFromWiis) {
    approvalHistoryFromWiis.forEach((historyItem) => {
      if (!historyItem.date) {
        undatedHistory.push(historyItem);
        return null;
      }
      datedHistory.push(historyItem);
      return null;
    });
  }


  // sort datedhistory to be most recent first, ie, the last first
  datedHistory.sort((a, b) => {
    const dateA = moment.tz(a.date, DEFAULT_TIMEZONE);
    const dateB = moment.tz(b.date, DEFAULT_TIMEZONE);
    if (dateA.isBefore(dateB)) {
      return 1;
    }
    if (dateA.isAfter(dateB)) {
      return -1;
    }
    // we return 1 by default as we there is a good chance we don't have an exact date. In this instance we
    // we sort in reverse order as the server gives us the crqs in chronlogical order, first to last
    return 1;
  });

  const fullApprovalHistory = [
    ...undatedHistory, // undated history (such as pending) before dated history
    ...datedHistory,
  ];



  return fullApprovalHistory;
};


const scanWorkInfoItemsForValues = (params = {}) => {
  const {
    workInfoItems,
    selectedNetwork,
    impactLevel,
  } = params;

  let valuesFromWorkInformationItems = {};


  if (selectedNetwork === MOBILE) {

    const businessJustificationWii = workInfoItems.find((wii) => wii.info_type === BUSINESS_JUSTIFICATION);

    const valuesFromBusinessJustification = unpackBusinessJustification(businessJustificationWii);

    valuesFromWorkInformationItems = {
      ...valuesFromWorkInformationItems,
      ...valuesFromBusinessJustification,
    };
  }

  if (selectedNetwork === FIXED && (impactLevel === IMPACT_LEVEL_1 || impactLevel === IMPACT_LEVEL_2)) {

    const businessJustificationWii = workInfoItems.find((wii) => wii.info_type === BUSINESS_JUSTIFICATION_FIXED);

    const valuesFromBusinessJustification = unpackBusinessJustification(businessJustificationWii);
    valuesFromWorkInformationItems = {
      ...valuesFromWorkInformationItems,
      ...valuesFromBusinessJustification,
    };
  }

  if (selectedNetwork === FIXED) {

    const networkItSecurityAssesmentNotRequiredWii = workInfoItems.find((wii) => wii.info_type === NETWORK_IT_SECURITY_ASSESSMENT_NOT_REQUIRED[selectedNetwork]);

    const valuesFromNetworkItSecurityAssesmentNotRequired = unpackNetworkItSecurityAssesmentNotRequired(networkItSecurityAssesmentNotRequiredWii);


    valuesFromWorkInformationItems = {
      ...valuesFromWorkInformationItems,
      ...valuesFromNetworkItSecurityAssesmentNotRequired,
    };

  }


  // This is a collection of WII which all map on to the same field
  const approvalHistoryWiis = workInfoItems.filter((wii) => (wii.info_type === PEER_REJECTED_TYPE[selectedNetwork]) || (wii.info_type === PEER_APPROVED_TYPE[selectedNetwork]));


  const approvalHistoryFromWiis = unpackApprovalHistoryWiis(approvalHistoryWiis);

  valuesFromWorkInformationItems = {
    ...valuesFromWorkInformationItems,
    approvalHistoryFromWiis,
  };

  return valuesFromWorkInformationItems;
};

const impactedLocations = (params) => (params.impacted_location ? params.impacted_location : null);
// convert crq server data into an object with keys of sectionId
// and values with the values for each section.
const getCrqSectionValuesFromApiData = (crqData, workInfoItems) => {

  const valuesBySection = {};

  fullSectionParameterFieldMap.forEach((section) => addValuesForSection({
    valuesBySection,
    section,
    crqData,
  }));

  const selectedNetwork = crqData.network;
  // Add the work info items in to the correct section
  valuesBySection[WORK_INFORMATION_ITEMS] = {
    [WORK_INFORMATION_ITEMS_FIELD_ID]: getModalDataForWorkInfoItems(workInfoItems, selectedNetwork),
  };

  const workInfo2 = 'WORK_INFORMATION_ITEMS';
  const wii3 = 'work-information-items';
  const relevantWii = valuesBySection[workInfo2][wii3].dataByFormSectionId;

  const trpWiiType = Object.entries(relevantWii).map((item2, index1) => {
    const worklog = 'work_items';

    if (item2[1].dataByFieldId[worklog].value === 'Service Impact Assessment') {
      return true;
    }
    return null;
  });
  const newTrpWiiType = trpWiiType.includes(true);

  // This is for checking if wii list includes audit wii type or not, if it includes we will  show TRP value as Yes.
  const trpWiiTypeFixed = Object.entries(relevantWii).map((item3, index1) => {
    const worklog2 = 'work_items';

    if (item3[1].dataByFieldId[worklog2].value === '24000') {
      return true;
    }
    return null;
  });
  const newTrpWiiTypeFixed = trpWiiTypeFixed.includes(true);


  window.sessionStorage.setItem('workInfoData', newTrpWiiType);
  let generalInfoWorkItemLogs = '';
  const genInfoWiiType = Object.entries(relevantWii).map((item2, index1) => {
    const wiiSummary = 'summary';
    if (item2[1].dataByFieldId[wiiSummary].value === 'Technology Recovery Plan') {
      generalInfoWorkItemLogs = item2[1].notes;
      return generalInfoWorkItemLogs;
    }
    return null;
  });
  const filterWiiNotes = genInfoWiiType.filter((message) => (message !== null));
  const technologyPlanExclusionNote = filterWiiNotes[0];
  window.sessionStorage.setItem('trpExclsuionNote', technologyPlanExclusionNote);

  window.sessionStorage.setItem('workInfoDataFixed', newTrpWiiTypeFixed);
  let generalInfoWorkItemLogsFixed = '';
  const genInfoWiiTypeFixed = Object.entries(relevantWii).map((item3, index1) => {
    const wiiSummary2 = 'summary';
    if (item3[1].dataByFieldId[wiiSummary2].value === 'Technology Recovery Plan') {
      generalInfoWorkItemLogsFixed = item3[1].notes;
      return generalInfoWorkItemLogsFixed;
    }
    return null;
  });
  const filterWiiNotesFixed = genInfoWiiTypeFixed.filter((message) => (message !== null));
  const technologyPlanExclusionNoteFixed = filterWiiNotesFixed[0];

  window.sessionStorage.setItem('trpExclsuionNoteFixed', technologyPlanExclusionNoteFixed);
  // Add the relationships values into the correct section
  // valuesBySection[RELATIONSHIPS] = {
  //   [ADD_RELATIONSHIPS]: getModalDataForRelationships(crqData.relationships, selectedNetwork),
  // };

  // Add the CiUnavailability values into the correct section
  valuesBySection[COMPLETION_REVIEW][CI_UNAVAILABILITY] = getModalDataForCiUnavailability(crqData.relationships, selectedNetwork);


  // Add the relationships values into the correct section
  valuesBySection[RELATIONSHIPS] = {
    [ADD_RELATIONSHIPS]: getModalDataForRelationships(crqData.relationships, selectedNetwork),
    [IMPACTED_LOCATION]: impactedLocations(crqData),
  };
  return valuesBySection;
};

// Manually add the display values for sla into the form data
// This is necessary as exisitng CRQs can have network or timing values that are not
// among the available options
// TODO: This should ideally be fixed within createFieldDataObjAndArray
const fixSlaDisplayValue = ({
  network,
  timing,
  formData,
}) => {
  const networkText = getNetworkTextForValue(network);
  const networkDisplayValues = [{ text: networkText, value: network }];
  formData.dataByFormSectionId[CHANGE_TYPE].dataByFieldId[selectNetworkParamsId].displayValues = networkDisplayValues;

  if (timing) {
    const timingStr = `${timing}`;
    // get text value directly from the JSON
    const slaText = getTimingTextForValue(network, timingStr);
    // create display values
    const displayValues = [{ text: slaText, value: timingStr }];
    // set the correct display values within the form data
    formData.dataByFormSectionId[CHANGE_QUESTIONS].dataByFieldId[selectChangeSlaId].displayValues = displayValues;
  }
};
// International update values
const internationalNetworkDisplayValue = ({
  formData,
}) => {
  const networkDisplayValues = [{ text: 'International', value: 'fixedInternational' }];
  formData.dataByFormSectionId[CHANGE_TYPE].dataByFieldId[selectNetworkParamsId].value = ['fixedInternational'];
  formData.dataByFormSectionId[CHANGE_TYPE].dataByFieldId[selectNetworkParamsId].displayValues = networkDisplayValues;
};

const internationalOLOServicesDisplayValue = ({
  formData,
}) => {
  const networkDisplayValues = [{ text: 'Yes', value: 'Yes' }];
  formData.dataByFormSectionId[CHANGE_TYPE].dataByFieldId[selectOLOReqIntServices].value = ['Yes'];
  formData.dataByFormSectionId[CHANGE_TYPE].dataByFieldId[selectOLOReqIntServices].displayValues = networkDisplayValues;
};
// Method to generate the formData redux structure based on crq values from the server
const generateFormDataFromCrq = ({
  crq,
  workInfoItems,
  userRoles,
}) => {
  wki.wki = workInfoItems;
  // some form fields are not stored on TIL. Instead they are stored in work information items that
  // we have to scan
  const workInfoItemValues = scanWorkInfoItemsForValues({
    workInfoItems,
    selectedNetwork: crq.network,
    impactLevel: crq.impact,
  });

  const fullCrqValues = {
    ...crq,
    ...workInfoItemValues,
  };


  // organise the crq server data values into sections
  const valuesBySection = getCrqSectionValuesFromApiData(fullCrqValues, workInfoItems);

  const {
    network,
    timing,
    risk_level: riskValue,
    submitted_date: dateCreated,
    status: rawStatus,
    coordinator: coordinatorId,
    coordinator_group: coordinatorGroup,
    coordinator_name: coordinatorName,
    peer_reviewer_name: peerReviewerName,
    peer_reviewer_group: peerReviewerGroup,
    peer_reviewer: peerReviewerId,
    requester_name: requesterName,
    requester,
    status_reason: statusReason,
    id: crqId,
    approvers,
    approvalHistoryFromWiis,
    other_line_operator: otherLineOperator,
    // eslint-disable-next-line camelcase
    postpone_reason1,
    // eslint-disable-next-line camelcase
    postpone_reason2,
    // eslint-disable-next-line camelcase
    postpone_reason3,
    // eslint-disable-next-line camelcase
    comms_status_flag,
    // eslint-disable-next-line camelcase
    circuit_check_analyst,
    // eslint-disable-next-line camelcase
    other_line_operator,
    // eslint-disable-next-line camelcase
    impacted_location,
    // eslint-disable-next-line camelcase
    adjacent_remedy_ref,
  } = fullCrqValues;
  const status = getStatusValueForParameter(rawStatus, network);
  const isIcmServices = getIsServiceFromICM(fullCrqValues.service);
  const isOlOInternationalService = getIsServiceFromOLOInternational(fullCrqValues.service);
  // get the sectionIds for the selected network
  // getSectionOrderForParsingCrqData returns all the sections that a coordinator would see
  // even if the current user is a requester, all sections should be visible
  // eslint-disable-next-line camelcase
  let sectionNetwork = other_line_operator === 'Yes' ? 'fixedOlo' : network;
  sectionNetwork = isIcmServices ? 'fixedInternational' : network;
  const sectionIds = getSectionOrderForParsingCrqData(sectionNetwork, status);
  if (!sectionIds) {
    console.error(`Unable to find sections for network ${network}`);
    return null;
  }



  const approvalHistory = inferAdditionalApprovalHistory({
    status,
    approvers,
    approvalHistoryFromWiis,
    peerReviewerGroup,
    peerReviewerName,
    peerReviewerId,
    statusReason,
  });

  // values that are not fields in the sections
  const nonFieldValues = {
    riskValue,
    dateCreated,
    status,
    coordinatorName,
    coordinatorGroup,
    coordinatorId,
    peerReviewerId,
    peerReviewerName,
    peerReviewerGroup,
    requesterName,
    requester,
    statusReason,
    crqId,
    approvalHistory,
    network,
    // OLO CRQ is defined as Yes
    otherLineOperator,
    postponeReason1: postpone_reason1,
    postponeReason2: postpone_reason2,
    postponeReason3: postpone_reason3,
    commsStatusFlag: comms_status_flag,
    assignToMeFlag: circuit_check_analyst,
    // otherLineOperator: other_line_operator,
    impactedLocation: impacted_location,
    // eslint-disable-next-line camelcase
    adjacentRemedyRef: adjacent_remedy_ref,
  };
  // sections that don't have their own store in redux. For example, CHANGE_REQUEST_SUMMARY doesn't have it's
  // own place in redux, it just dislays the data of other sections
  const sectionIdsWithoutData = [
    CHANGE_REQUEST_SUMMARY,
  ];

  const formData = {
    dataByFormSectionId: {},
    formSectionsByDisplayOrder: [],
    ...nonFieldValues,
  };

  sectionIds.forEach((sectionId, index) => {
    // lookup the getCurrentFields function for the section
    const getCurrentFields = createCrqSectionGetCurrentFields[sectionId];
    if (!getCurrentFields) {
      // If a section saves data to redux, we expect it to have a getCurrentFields function.
      // If it doesn't, we want to fire an error
      if (!sectionIdsWithoutData.includes(sectionId)) {
        console.error(`Cannot find getCurrentFields for field sectionId: ${sectionId}`);
      }
      return;
    }
    // retrieve the section fields.
    // values is passed in as {}, to replicate visiting a form section for the first time
    const sectionFields = getCurrentFields({
      formData, values: {}, userRoles, network,
    });
    const sectionValues = valuesBySection[sectionId];
    let ClearApprovers = '';
    let Status = '';
    if (sectionId === APPROVERS_SECTION) {
      ClearApprovers = nonFieldValues.statusReason ? nonFieldValues.statusReason : null;
      Status = nonFieldValues.status ? nonFieldValues.status : null;
    }
    // get a values object for the section populated with the server values
    const populatedValues = getPopulatedValuesForSection({
      sectionFields, sectionValues, ClearApprovers, Status, network,
    });
    // get current fields again, but this time with the populated values
    // this should handle any overwrites
    const updatedFields = getCurrentFields({
      formData, values: populatedValues, userRoles, network,
    });
    // now create the sectionData for the form
    const sectionData = createFieldDataObjAndArray({
      currentFields: updatedFields,
      values: populatedValues,
      selectedNetwork: network,
      // bypass any overwrites from the form, as the user should see all values set independent of role
      noOverwrite: true,
    });
    const sectionTitle = prefixStringWithIndexPlusOne(SECTION_TITLES[sectionId], index);
    // add the section data, id and title into formData
    formData.formSectionsByDisplayOrder.push(sectionId);
    formData.dataByFormSectionId[sectionId] = {
      ...sectionData,
      sectionId,
      sectionTitle,
    };
  });

  // Need to fix the display value for SLA, as existing CRQs can have sla values that aren't in the dropdown
  fixSlaDisplayValue({
    network,
    timing,
    formData,
  });
  // International network update values
  if (isIcmServices) {
    internationalNetworkDisplayValue({
      formData,
    });
  }
  // OLO international field update for CHANGE_TYPE
  if (isOlOInternationalService) {
    internationalOLOServicesDisplayValue({
      formData,
    });
  }
  return formData;
};

export {
  generateFormDataFromCrq,
  getModalDataForWorkInfoItems,
  getModalDataForRelationships,
};
